import type React from "react"

const LoaderSpinner: React.FC<{ size?: number }> = ({ size = 20 }) => (
  <span
    style={{
      display: "inline-block",
      width: size,
      height: size,
      verticalAlign: "middle",
    }}
    className="flex items-center justify-center"
  >
    <svg
      width={size}
      height={size}
      viewBox="0 0 50 50"
      style={{
        display: "block",
        filter: "drop-shadow(0 0 8px rgba(255,255,255,0.7))" // Increased blur and opacity
      }}
    >
      <circle cx="25" cy="25" r="20" fill="none" stroke="white" strokeWidth="5" />
      <circle
        cx="25"
        cy="25"
        r="20"
        fill="none"
        stroke="#ad4c51"
        strokeWidth="5"
        strokeDasharray="25 100"
        strokeDashoffset="0"
        strokeLinecap="round"
      >
        <animateTransform
          attributeName="transform"
          type="rotate"
          from="0 25 25"
          to="360 25 25"
          dur="0.8s"
          repeatCount="indefinite"
        />
      </circle>
    </svg>
  </span>
)

export default LoaderSpinner
